import { put, call } from 'redux-saga/effects'; 

import { csvTemplateImport } from '../../services/settings/csvTemplatesImportService'; 

import { SHOW_LOADER, HIDE_LOADER, CSV_TEMPLATE_IMPORT_SUCCESS, CSV_TEMPLATE_IMPORT_ERROR } from '../../actions';

export function* csvTemplateImportSaga(payload) {
  try {
    yield put({ type: SHOW_LOADER})
    const response = yield call(csvTemplateImport, payload);
    yield put({ type: CSV_TEMPLATE_IMPORT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: CSV_TEMPLATE_IMPORT_ERROR, error });
  }finally{
    yield put({ type: HIDE_LOADER})
  }
}





